import { render, staticRenderFns } from "./OfferInfo.vue?vue&type=template&id=056a7780&scoped=true&"
import script from "./OfferInfo.vue?vue&type=script&lang=js&"
export * from "./OfferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a7780",
  null
  
)

export default component.exports